import API from './api';

const athletesService = {

    getGroupAthletes: (groupId) => API({
        url: `athletes?group_id=${groupId}&include=team,group,maxes&supportsDefaults=true`,
        method: 'GET',
    }),

    getTeamAthletes: (teamId) => API({
        url: `athletes?team_id=${teamId}&include=team,group,maxes&supportsDefaults=true`,
        method: 'GET',
    }),

    getAllAthletes: (organizationId) => API({
        url: `athletes?organization_id=${organizationId}&include=team,group,maxes&supportsDefaults=true`,
        method: 'GET',
    }),

    getAthlete: (athleteId) => API({
        url: `athletes/${athleteId}?include=team,group,account_invite&supportsDefaults=true`,
        method: 'GET',
    }),

    createAthlete: (json) => API({
        url: 'athletes',
        method: 'POST',
        json,
    }),

    patchAthlete: (json) => API({
        url: `athletes/${json.id}?include=team,group&supportsDefaults=true`,
        method: 'PATCH',
        json,
    }),

    // AthleteInvite: Create invitation to connect an athlete profile with a user account
    createAthleteInvite: (athleteId, email) => API({
        url: `athletes/${athleteId}/account-invite`,
        method: 'POST',
        json: { email },
    }),

    // AthleteInvite: Cancel invitation to connect an athlete profile with a user account
    cancelAthleteInvite: (athleteId) => API({
        url: `athletes/${athleteId}/account-invite`,
        method: 'DELETE',
    }),

    // AthleteInvite: Get invitation details for an athlete
    getAthleteInvite: (athleteId) => API({
        url: `athletes/${athleteId}/account-invite`,
        method: 'GET',
    }),

    uploadAvatar: (athleteId) => API({
        url: `athletes/${athleteId}/upload`,
        method: 'PUT',
    }),

    importAthletes: (file) => {
        const formData = new FormData();
        formData.append('csv', file, file.name);

        return API({
            url: `athletes/import`,
            method: 'POST',
            formData,
        });
    },

    patchAthleteGroup: (athleteId, groupId) => API({
        url: `athletes/${athleteId}`,
        method: 'PATCH',
        json: { group_id: groupId },
    }),

    removeAthlete: (athleteId) => API({
        url: `athletes/${athleteId}`,
        method: 'DELETE',
    }),

    patchMultipleAthleteCategories: (athlete_ids, group_id) => API({
        url: `athletes?supportsDefaults=true`,
        method: 'PATCH',
        json: { athlete_ids, group_id },
    }),

    removeMultipleAthletes: (athlete_ids) => API({
        url: `athletes`,
        method: 'DELETE',
        json: { athlete_ids },
    }),

    // AthleteInvite: Get invitation details using an invite code
    getAthleteInviteByCode: (inviteCode) => API({
        url: `athlete-account-invites/${inviteCode}`,
        method: 'GET',
        noOrg: true, // Skip organization header for invite endpoints
    }),

    // AthleteInvite: Accept an invitation to connect athlete profile to current account
    acceptAthleteInvite: (inviteCode) => API({
        url: `athlete-account-invites/${inviteCode}/accept`,
        method: 'POST',
        noOrg: true, // Skip organization header for invite endpoints
    }),

    // AthleteInvite: Pre-accept an invitation before creating an account
    preAcceptAthleteInvite: (inviteCode) => API({
        url: `athlete-account-invites/${inviteCode}/pre-accept`,
        method: 'POST',
        noOrg: true, // Skip organization header for invite endpoints
    }),

};

export default athletesService;
